module.exports = __webpack_public_path__ + "static/img/blog-06.731d5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-06.jpg
// module id = mfiv
// module chunks = 7